import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        courseId: '=',
        course: '='
    },
    template: `
            <loader-icon ng-if="vm.saving" overlay="true"></loader-icon>
            <div class="well color01">
                <div class="heading01">
                    <h1>{{ 'planningGroup.Automated planning groups' | translate }}</h1>
                    <a
                        ng-if="vm.canManageAutomatedPlanningGroups && vm.canAddApg && !vm.course.isArchived"
                        class="btn add"
                        ui-sref="authorized.courses.courses.edit.occurrence.automated.add.general()">{{ 'planningGroup.Add group' | translate }}</a>
                </div>
                <p ng-if="!vm.canAddApg" class="desc muted" ng-bind-html="vm.automatedGroupIntroductionNoOnlineTraining"></p>
                <p ng-if="vm.canAddApg" class="desc muted" ng-bind-html="vm.automatedGroupIntroduction"></p>
                <div ng-if="vm.list.items.length" class="tablewrapper" ng-click="vm.closeAllMenus()">
                    <table class="data01" ng-if="!vm.list.loading && vm.list.items.length">
                        <thead>
                            <tr>
                                <th>{{ 'planningGroup.Name' | translate }}</th>
                                <th>{{ 'planningGroup.Users' | translate }}</th>
                                <th>{{ 'planningGroup.Version' | translate }}</th>
                                <th>{{ 'planningGroup.Site' | translate }}</th>
                                <th>{{ 'planningGroup.Status' | translate }}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr ng-repeat="item in vm.list.items">
                                <td>{{ item.name }}</td>
                                <td>{{ item.userCount }}</td>
                                <td>{{ item.courseVersion.name }}</td>
                                <td ng-if="item.siteNames">
                                    <span style="display: block; max-width: 220px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                                        title="{{ item.siteNames }}">{{ item.siteNames }}</span>
                                </td>
                                <td ng-if="!item.siteNames">
                                    {{ 'planningGroup.All sites' | translate }}
                                    </br>
                                    <small ng-if="item.excludeExternalSites">({{ 'planningGroup.External site excluded' | translate }})</small>
                                </td>
                                <td>{{ vm.AUTOMATED_PLANNING_GROUP_STATUS_ENUM.LABELS[item.status] }}</td>
                                <td class="actions">
                                    <div class="action-menu">
                                        <button
                                            class="btn"
                                            aria-haspopup="true"
                                            aria-expanded="{{ !!vm.actions[item.id] }}"
                                            ng-click="vm.openActionMenu($event, item.id)"
                                            ><span>&nbsp;</span>
                                        </button>
                                        <ul role="menu" ng-if="vm.actions[item.id]" ng-click="$event.stopPropagation()">
                                            <li>
                                                <a ui-sref="authorized.courses.courses.edit.occurrence.automated.edit.general({ id: vm.$state.params.id, planningGroupId: item.id})">
                                                    <span ng-if="vm.canManageAutomatedPlanningGroups">{{ 'general.Edit' | translate }}</span>
                                                    <span ng-if="!vm.canManageAutomatedPlanningGroups">{{ 'general.View' | translate }}</span>
                                                </a>
                                            </li>
                                            <li ng-if="vm.canManageAutomatedPlanningGroups && item.isDeletable">
                                                <a ng-click="vm.delete(item)">
                                                    {{ 'general.Delete' | translate }}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <pagination list="vm.list"></pagination>
                </div>
            </div>
    `
})

export default class {
    constructor ($translate, $state, ListFactory, AUTOMATED_PLANNING_GROUP_STATUS_ENUM, PrivilegeService,
                 AutomatedPlanningGroupResource, OccurrenceResource, CourseVersionResource, ModalService, toastr,
                 $document, $timeout) {
        this.$translate = $translate;
        this.$state = $state;
        this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM = AUTOMATED_PLANNING_GROUP_STATUS_ENUM;
        this.PrivilegeService = PrivilegeService;
        this.AutomatedPlanningGroupResource = AutomatedPlanningGroupResource;
        this.OccurrenceResource = OccurrenceResource;
        this.CourseVersionResource = CourseVersionResource;
        this.ListFactory = ListFactory;
        this.ModalService = ModalService;
        this.toastr = toastr;
        this.actions = [];
        this.$timeout = $timeout;

        // Add document click handler to close menus when clicking outside
        this.$document = $document;
        this.$document.on('click', () => {
            // Only close menus if there are any open
            if (this.actions.length > 0) {
                // Use $timeout to ensure immediate UI update
                this.$timeout(() => {
                    this.closeAllMenus();
                }, 0);
            }
        });
    }

    $onInit () {
        this.fetchList();
        this.canManageAutomatedPlanningGroups = this.PrivilegeService.canManageAutomatedPlanningGroups();
        this.automatedGroupIntroduction = this.$translate.instant('planningGroup.From here you can start adding');
        this.automatedGroupIntroductionNoOnlineTraining = this.$translate.instant('planningGroup.From here you can start adding no online');

        this.canAddApg = false;
        this.CourseVersionResource.query({ courseId: this.courseId, isPlanningGroupSearch: true })
            .$promise
            .then((versions) => {
                this.canAddApg = versions.length;
            });
    }

    fetchList () {
        this.list = this.ListFactory.createWithPagination(this.queryGroups.bind(this));
        this.list.fetch({ courseId: this.courseId, expand: 'courseVersion,sites' });
    }

    // pagination calls list.fetch() directly, so the decoration has to happen on every
    // response rather than on the promise of the first one
    queryGroups (query, postParameters, callback) {
        return this.AutomatedPlanningGroupResource.query(query, postParameters, (items, headers) => {
            items.forEach(item => {
                item.isDeletable = item.status === 'STOPPED' || item.status === 'CANCELLED' || item.status === 'NOT_STARTED';
                // an empty site list means the group covers every site, the column says so instead
                item.siteNames = (item.sites || []).map(site => site.name).join(', ');
            });
            callback(items, headers);
        });
    }

    delete (item) {
        this.closeAllMenus();
        const confirmMessage = this.$translate.instant('planningGroup.Are you sure you wish to delete this planning group?');

        this.ModalService.confirm(confirmMessage, 'medium').then(() => {
            this.saving = true;
            this.AutomatedPlanningGroupResource.delete({ id: item.id }).$promise
                .then(() => {
                    this.saving = false;
                    this.fetchList();
                    this.toastr.success(this.$translate.instant('planningGroup.Planning group deleted'));
                });
        });
    }

    openActionMenu ($event, rowId) {
        $event.stopPropagation();
        $event.preventDefault();

        // First close all menus, then toggle the clicked one
        this.$timeout(() => {
            // If this menu is already open, just close it
            if (this.actions[rowId]) {
                this.actions = [];
            }
            else {
                // Close all menus and open only this one
                this.actions = [];
                this.actions[rowId] = true;
            }
        }, 0);
    }
    closeAllMenus () {
        this.$timeout(() => {
            this.actions = [];
        }, 0);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/edit/occurrence/automated/planningGroup/list/index.js